// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".help h4 {\n  margin-bottom: 0px;\n}\n.help ul {\n  list-style: disc;\n  padding-left: 5px;\n  margin: 0px 0px 20px 12px;\n}\n", ""]);
// Exports
module.exports = exports;
